import _ from 'lodash';

export const setDefaultMeta = (prefix) => (r) => {
  prefix = prefix || '';
  const newRoute = {
    ...r,
    path: `${prefix}${r.path}`,
    meta: _.defaults({
      auth: true,
    }, r.meta),
  };
  if (_.isArray(r.children) && !_.isEmpty(r.children)) {
    newRoute.children = _.map(r.children, setDefaultMeta(''));
  }
  return newRoute;
};

export const setDefaults = (routes: Array<any>, prefix?: string) => _.map(routes, setDefaultMeta(prefix));
